// Paper reporting only; benchmark units remain the authoritative settlement source.
export const FLAT_REPORT_STAKE = 100;
export const isFlatReport = (id?: string) => id === 'refit-brain-max3-v1';
export const reportDollars = (u: number | null | undefined): number | null =>
 u == null || !Number.isFinite(u) ? null : Math.round(u * FLAT_REPORT_STAKE * 100) / 100;
export const reportMoney = (v: number | null | undefined) => v == null ? '—' :
 new Intl.NumberFormat('en-AU', {style:'currency',currency:'AUD'}).format(v);
export const reportUnits = (id: string | undefined, u: number | null | undefined) =>
 isFlatReport(id) ? reportMoney(reportDollars(u)) : u == null ? '—' : u.toFixed(2)+'u';
export function flatReportRow<T extends {stream_id?:string;decision:string;status:string;result:string|null;benchmark_pnl_units?:number|null;applied_stake:number|null;paper_pnl_dollars:number|null}>(row:T):T {
 if (!isFlatReport(row.stream_id)) return row;
 return {...row,
 applied_stake: row.decision === 'BET' ? (row.result?.toLowerCase()==='void' ? 0 : FLAT_REPORT_STAKE) : null,
 paper_pnl_dollars: row.decision === 'BET' && row.status === 'SETTLED' ? reportDollars(row.benchmark_pnl_units) : null};
}
